import { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';

export type DeletePoolModalProps = {
  isPending?: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

export const DeleteModal: FC<DeletePoolModalProps> = ({ onClose, onSuccess, isPending }) => (
  <div className="m-2 flex w-full min-w-[300px] flex-col gap-8 rounded bg-white p-4 xlg:w-[453px]">
    <div className="flex flex-col gap-4">
      <span className="text-xl font-[550] text-gray-700">
        <AppFormattedMessage
          id="DELETE_POOL"
          values={{
            text: <AppFormattedMessage id="SCENARIO" />,
          }}
        />
        ?
      </span>
      <span className="text-xs font-[450] text-gray-500">
        <AppFormattedMessage id="DELETE_SCENARIO_WARNING" />
      </span>
    </div>
    <div className="flex h-11 justify-end gap-4">
      <Button
        className="h-full w-fit rounded border border-gray-300 px-6 py-[10px] text-sm font-[450] text-gray-700"
        onClick={onClose}
        styleType="NONE"
      >
        <AppFormattedMessage id="NO_KEEP_3" />
      </Button>
      <Button
        className="h-full w-fit bg-fireside-600 px-6 py-[10px] text-sm font-[550] text-white"
        isLoading={isPending}
        onClick={onSuccess}
        styleType="NONE"
      >
        <AppFormattedMessage id="DELETE" />
      </Button>
    </div>
  </div>
);
